import { PORTAL_CLASS_NAME } from '../constants/portalClassName'

/*
Modal, Drawer and Dropdown mount into document via a portal and have PORTAL_CLASS_NAME. 
Since portals are appended, the last matching element in document order is the most recently
opened (i.e. topmost) overlay.
*/
export const isTopmostPortalElement = (element: Element | null): boolean => {
  if (!element) {
    return true
  }
  const portalElements = document.querySelectorAll(`.${PORTAL_CLASS_NAME}`)
  return portalElements[portalElements.length - 1] === element
}
